import { render, staticRenderFns } from "./CalculoExtratoSecoDesengordurado.vue?vue&type=template&id=4a33304e&scoped=true&"
import script from "./CalculoExtratoSecoDesengordurado.vue?vue&type=script&lang=js&"
export * from "./CalculoExtratoSecoDesengordurado.vue?vue&type=script&lang=js&"
import style0 from "./CalculoExtratoSecoDesengordurado.vue?vue&type=style&index=0&id=4a33304e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a33304e",
  null
  
)

export default component.exports